import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FiBook,
  FiArrowLeft,
  FiTrash2,
  FiClock,
  FiBookOpen,
  FiTag,
} from 'react-icons/fi';
import Sidebar from '../../Sidebar';
import { getAccountScopedLocalStorageKey } from '../../../utils/utils';

const getScopedLocalStorageItem = (key) => {
  const scopedKey = getAccountScopedLocalStorageKey(key);
  return scopedKey ? localStorage.getItem(scopedKey) : null;
};

const setScopedLocalStorageItem = (key, value) => {
  const scopedKey = getAccountScopedLocalStorageKey(key);
  if (!scopedKey) return false;
  localStorage.setItem(scopedKey, value);
  return true;
};

const TAGENotebook = () => {
  const navigate = useNavigate();
  const [notebook, setNotebook] = useState([]);
  const [filterType, setFilterType] = useState('all');

  useEffect(() => {
    loadNotebook();
  }, []);

  const loadNotebook = () => {
    const savedNotebook = JSON.parse(
      getScopedLocalStorageItem('tage_notebook') || '[]'
    );
    // Sort by most recent first
    const sortedNotebook = savedNotebook.sort(
      (a, b) => new Date(b.savedAt) - new Date(a.savedAt)
    );
    setNotebook(sortedNotebook);
  };

  const deleteNote = (noteId) => {
    const updatedNotebook = notebook.filter((note) => note.id !== noteId);
    setNotebook(updatedNotebook);
    setScopedLocalStorageItem('tage_notebook', JSON.stringify(updatedNotebook));
  };

  const clearAllNotes = () => {
    if (
      window.confirm(
        'Êtes-vous sûr de vouloir supprimer toutes vos notes ? Cette action est irréversible.'
      )
    ) {
      setNotebook([]);
      setScopedLocalStorageItem('tage_notebook', JSON.stringify([]));
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  };

  const filteredNotes =
    filterType === 'all'
      ? notebook
      : notebook.filter((note) => note.lessonType === filterType);

  const lessonTypes = [...new Set(notebook.map((note) => note.lessonType))];

  return (
    <div className="layout">
      <Sidebar />
      <div className="content">
        <div style={{ padding: '2rem', maxWidth: '1200px', margin: '0 auto' }}>
          {/* Header */}
          <div style={{ marginBottom: '2rem' }}>
            <button
              onClick={() => navigate(-1)}
              style={{
                background: 'none',
                border: 'none',
                color: 'var(--liwaza-primary)',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                fontSize: '1rem',
                marginBottom: '1rem',
              }}
            >
              <FiArrowLeft /> Retour au TAGE MAGE
            </button>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div>
                <h1
                  style={{
                    color: 'var(--liwaza-on-surface)',
                    marginBottom: '0.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem',
                  }}
                >
                  <FiBook />
                  Mon Livre de Notes
                </h1>
                <p
                  style={{
                    color: 'var(--liwaza-on-surface-variant)',
                    fontSize: '1.1rem',
                  }}
                >
                  Tous vos récapitulatifs de cours TAGE MAGE enregistrés
                </p>
              </div>

              {notebook.length > 0 && (
                <button
                  onClick={clearAllNotes}
                  style={{
                    background: 'var(--liwaza-error-container)',
                    color: 'var(--liwaza-error)',
                    border: 'none',
                    padding: '0.75rem 1rem',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    fontSize: '0.9rem',
                  }}
                >
                  <FiTrash2 size={16} />
                  Tout supprimer
                </button>
              )}
            </div>
          </div>

          {/* Filters */}
          {lessonTypes.length > 1 && (
            <div
              style={{
                display: 'flex',
                gap: '1rem',
                marginBottom: '2rem',
                flexWrap: 'wrap',
              }}
            >
              <button
                onClick={() => setFilterType('all')}
                style={{
                  padding: '0.5rem 1rem',
                  border: 'none',
                  borderRadius: '8px',
                  background:
                    filterType === 'all'
                      ? 'var(--liwaza-primary)'
                      : 'var(--liwaza-surface-container)',
                  color:
                    filterType === 'all' ? 'white' : 'var(--liwaza-on-surface)',
                  cursor: 'pointer',
                  fontWeight: filterType === 'all' ? 600 : 400,
                }}
              >
                Tous ({notebook.length})
              </button>
              {lessonTypes.map((type) => (
                <button
                  key={type}
                  onClick={() => setFilterType(type)}
                  style={{
                    padding: '0.5rem 1rem',
                    border: 'none',
                    borderRadius: '8px',
                    background:
                      filterType === type
                        ? 'var(--liwaza-primary)'
                        : 'var(--liwaza-surface-container)',
                    color:
                      filterType === type
                        ? 'white'
                        : 'var(--liwaza-on-surface)',
                    cursor: 'pointer',
                    fontWeight: filterType === type ? 600 : 400,
                  }}
                >
                  {type} ({notebook.filter((n) => n.lessonType === type).length}
                  )
                </button>
              ))}
            </div>
          )}

          {/* Notes Grid */}
          {filteredNotes.length === 0 ? (
            <div
              style={{
                background: 'var(--liwaza-surface-container)',
                padding: '4rem 2rem',
                borderRadius: '12px',
                textAlign: 'center',
              }}
            >
              <FiBook
                size={64}
                style={{
                  color: 'var(--liwaza-on-surface-variant)',
                  marginBottom: '1rem',
                }}
              />
              <h3
                style={{
                  color: 'var(--liwaza-on-surface)',
                  marginBottom: '0.5rem',
                }}
              >
                {filterType === 'all'
                  ? 'Aucune note enregistrée'
                  : `Aucune note pour ${filterType}`}
              </h3>
              <p style={{ color: 'var(--liwaza-on-surface-variant)' }}>
                Enregistrez les récapitulatifs de vos cours pour les retrouver
                ici
              </p>
            </div>
          ) : (
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
                gap: '1.5rem',
              }}
            >
              {filteredNotes.map((note) => (
                <div
                  key={note.id}
                  style={{
                    background: 'var(--liwaza-surface-container)',
                    padding: '1.5rem',
                    borderRadius: '12px',
                    border: '1px solid var(--liwaza-outline-variant)',
                    transition: 'all 0.2s',
                    cursor: 'pointer',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = 'var(--liwaza-shadow-md)';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = 'none';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  {/* Card Header */}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'start',
                      marginBottom: '1rem',
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.5rem',
                          marginBottom: '0.5rem',
                        }}
                      >
                        <FiTag
                          size={14}
                          style={{ color: 'var(--liwaza-primary)' }}
                        />
                        <span
                          style={{
                            fontSize: '0.75rem',
                            color: 'var(--liwaza-primary)',
                            fontWeight: 600,
                          }}
                        >
                          {note.lessonType}
                        </span>
                      </div>
                      <h3
                        style={{
                          color: 'var(--liwaza-on-surface)',
                          fontSize: '1.1rem',
                          marginBottom: '0.5rem',
                          cursor: 'pointer',
                        }}
                        onClick={() =>
                          navigate(`/exams/tage/lesson/${note.lessonId}`)
                        }
                      >
                        {note.lessonTitle}
                      </h3>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.25rem',
                          fontSize: '0.8rem',
                          color: 'var(--liwaza-on-surface-variant)',
                        }}
                      >
                        <FiClock size={12} />
                        {formatDate(note.savedAt)}
                      </div>
                    </div>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        deleteNote(note.id);
                      }}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: 'var(--liwaza-error)',
                        cursor: 'pointer',
                        padding: '0.5rem',
                        borderRadius: '4px',
                        transition: 'background 0.2s',
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.background =
                          'var(--liwaza-error-container)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.background = 'none';
                      }}
                      title="Supprimer cette note"
                    >
                      <FiTrash2 size={16} />
                    </button>
                  </div>

                  {/* Concepts List */}
                  <div
                    style={{
                      background: 'var(--liwaza-surface-container-highest)',
                      padding: '1rem',
                      borderRadius: '8px',
                    }}
                  >
                    <h4
                      style={{
                        fontSize: '0.85rem',
                        color: 'var(--liwaza-on-surface-variant)',
                        marginBottom: '0.75rem',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                      }}
                    >
                      <FiBookOpen size={14} />
                      Concepts clés
                    </h4>
                    <ul
                      style={{
                        fontSize: '0.85rem',
                        color: 'var(--liwaza-on-surface)',
                        listStyle: 'none',
                        padding: 0,
                        margin: 0,
                      }}
                    >
                      {note.concepts.slice(0, 5).map((concept, index) => (
                        <li
                          key={index}
                          style={{
                            padding: '0.4rem 0',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '0.5rem',
                          }}
                        >
                          <span style={{ color: 'var(--liwaza-primary)' }}>
                            •
                          </span>
                          <span>{concept}</span>
                        </li>
                      ))}
                      {note.concepts.length > 5 && (
                        <li
                          style={{
                            padding: '0.4rem 0',
                            fontSize: '0.75rem',
                            color: 'var(--liwaza-on-surface-variant)',
                            fontStyle: 'italic',
                          }}
                        >
                          +{note.concepts.length - 5} autres concepts
                        </li>
                      )}
                    </ul>
                  </div>

                  {/* View Lesson Button */}
                  <button
                    onClick={() =>
                      navigate(`/exams/tage/lesson/${note.lessonId}`)
                    }
                    style={{
                      width: '100%',
                      marginTop: '1rem',
                      padding: '0.75rem',
                      background: 'var(--liwaza-primary)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '0.5rem',
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      transition: 'background 0.2s',
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = 'var(--liwaza-primary-hover)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = 'var(--liwaza-primary)';
                    }}
                  >
                    <FiBookOpen size={16} />
                    Voir la leçon
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TAGENotebook;
